import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  styleCustomerColor,
  styleTopSecBackgroundColor,
  styleTopSecColor,
} from "./helper";
import moment from "moment";
import Modal from "react-modal";
import PaginatedItems from "../../../common/Pagination";
import { HistoryPopup } from "./HistoryPopup";
import {
  GetPartialTestDetailsList,
  acceptAllCaseAction,
  getAppoinmentAction,
  getAppointmentQueueFilterCountsAction,
  updateAppoinmentStatusAction,
  updateRejectStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import { ConfirmationPopup } from "./ConfirmationPopup";
import { UploadReportPopup } from "./UploadReportPopup";
import { RejectConfirmationPopup } from "./RejectConfirmationPopup";
import { getNetworkMenuId, getRole, IS_SHOW_POPUP } from "../../../Utils/types";
import { getDispatch } from "../../../Utils/helper";
import { PartialShow } from "./PartialShow";

const AppointmentCardContainer = ({
  searchFilter,
  apiParams,
  funnelSelected,
  setMultiSelect,
  multiSelect,
}) => {
  const [isHistoryPopup, setIsHistoryPopup] = useState(null);
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(null);
  const [isUploadReportPopup, setIsUploadReportPopup] = useState(null);
  const [isRejectPopup, setIsRejectPopup] = useState(null);
  const [isAcceptAll, setIsAcceptAll] = useState(false);
  const [isShowMoreAddress, setIsShowMoreAddress] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [cardIndex, setCardIndex] = useState(null);
  const [partialShow,setPartialShow] = useState({
    open:false,
    data:null
  });
  const appoinmentReducer = useSelector((state) => state?.AppoinmentReducer);
  const getAppoinmentDetail = appoinmentReducer?.getAppoinmentDetail;
  const dispatch = useDispatch();
  const checkShowPopupAcceptRejectHandler = (ele, DCConfirmationFlag) => {
    dispatch(
      updateRejectStatusAction(
        {
          appointmentId: ele?.appointmentId,
          isApproved: DCConfirmationFlag === "A" ? "true" : "false",
          target: ele?.valueType,
          remarks: "",
          validate: true,
          timeSlot: moment(ele?.appointmentDateTime).format(
            "YYYY-MM-DD hh:mm A"
          ),
          availableTimeSlots: "",
          AppointmentStatusId: ele?.appointmentstatusid,
        },
        getAppoinmentAction,
        searchFilter,
        apiParams,
        setIsUploadReportPopup,
        setIsConfirmationPopup,
        setIsRejectPopup
      )
    );
  };

  const checkShowPopupHandler = (ele, DCConfirmationFlag) => {
    dispatch(
      updateAppoinmentStatusAction(
        {
          valueType: ele?.valueType,
          appointmentId: ele?.appointmentId,
          DCConfirmationFlag: DCConfirmationFlag,
          Validate: true,
          AppointmentDate: moment(ele?.appointmentDateTime).format(
            "YYYY-MM-DD hh:mm A"
          ),
          AppointmentStatusId: ele?.appointmentstatusid,
        },
        getAppoinmentAction,
        searchFilter,
        apiParams,
        setIsUploadReportPopup,
        setIsConfirmationPopup,
        setIsRejectPopup
      )
    );
  };

  const AcceptAllHandler = async () => {
    const temp = isAcceptAll
      ? []
      : multiSelect?.map((ele) => {
          return {
            appointmentId: ele?.appointmentId,
            isApproved: "true",
            target: ele?.valueType,
            remarks: "",
            validate: false,
            timeSlot: moment(ele?.appointmentDateTime).format(
              "YYYY-MM-DD hh:mm A"
            ),
            availableTimeSlots: "",
            AppointmentStatusId: ele?.appointmentstatusid,
          };
        });
    await dispatch(
      acceptAllCaseAction({
        searchFilter: searchFilter,
        acceptAll: isAcceptAll,
        appointments: temp,
      })
    );
    dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams, page: 1 }));
    dispatch(
      getAppointmentQueueFilterCountsAction({
        ...searchFilter,
        ...apiParams,
        page: 1,
      })
    );
    setIsAcceptAll(false);
    setMultiSelect([]);
  };
  const ChangeStatusHandler = async (ele, DCConfirmationFlag, msg) => {
    await setIsConfirmationPopup({
      isOpen: true,
      DCConfirmationFlag: DCConfirmationFlag,
      message: msg,
      cardDetails: ele,
    });
    DCConfirmationFlag === "A" &&
      (await checkShowPopupAcceptRejectHandler(ele, "A"));
    (DCConfirmationFlag === "S" || DCConfirmationFlag === "N") &&
      (await checkShowPopupHandler(ele, DCConfirmationFlag));
  };

  const filterAppointmentId = (ele) =>
    multiSelect?.filter((item) => item.appointmentId !== ele?.appointmentId);

  const appointmentIds = appoinmentReducer?.getAppoinmentQueueDetail?.map(
    (ele) => {
      return ele?.appointmentId;
    }
  );
  const multiSelectAppointmentIds = multiSelect?.map((ele) => {
    return ele?.appointmentId;
  });

  return (
    <>
      <div className="select_all_row">
        {funnelSelected === "pendingConfirmation" ? (
          <>
            {appoinmentReducer?.getAppoinmentQueueDetail?.length !== 0 && (
              <div style={{ gap: "10px", display: "flex" }}>
                <input
                  type="checkbox"
                  onClick={(e) =>
                    e?.target?.checked
                      ? (setIsSelectAll(true),
                        setMultiSelect([
                          ...new Set(
                            [
                              ...multiSelect,
                              ...appoinmentReducer?.getAppoinmentQueueDetail?.map(
                                (ele) => {
                                  return ele;
                                }
                              ),
                            ].map((item) => item)
                          ),
                        ]))
                      : (setMultiSelect(
                          multiSelect?.length === 10
                            ? []
                            : multiSelect?.filter(
                                (item) =>
                                  !appointmentIds.includes(item?.appointmentId)
                              )
                        ),
                        setIsAcceptAll(false),
                        setIsSelectAll(false))
                  }
                  checked={
                    appointmentIds?.every((r) =>
                      multiSelectAppointmentIds?.includes(r)
                    ) && isSelectAll
                  }
                  className="form-check-input"
                />
                Select All
              </div>
            )}
            <div style={{ display: "flex", alignItems: "center" }}>
              <p>
                {multiSelect?.length && !isAcceptAll ? (
                  `${multiSelect?.length} appointments are selected.`
                ) : (
                  <></>
                )}
              </p>
              {multiSelect?.length >=
                appoinmentReducer?.getAppoinmentQueueDetail?.length && (
                <p>
                  {isAcceptAll &&
                    `All  ${getAppoinmentDetail?.totalRow} appointments are selected.`}
                  &nbsp;
                  {!isAcceptAll && getAppoinmentDetail?.totalRow > 10 ? (
                    <span
                      className="select_all_primary_cases"
                      onClick={() => setIsAcceptAll(true)}
                    >
                      Select all {getAppoinmentDetail?.totalRow} appointments
                    </span>
                  ) : (
                    <></>
                  )}
                </p>
              )}
              {multiSelect?.length ? (
                <span
                  className="select_all_primary_cases"
                  onClick={AcceptAllHandler}
                >
                  Accept All
                </span>
              ) : null}
            </div>
          </>
        ) : (
          <div></div>
        )}
        <div></div>
      </div>
      <div className="__appointment_card-container">
        {appoinmentReducer?.getAppoinmentQueueDetail?.map((ele, index) => {
          return (
            <div
              className={`appoinment-detail ${
                ele?.status === "Pending"
                  ? "pending-appoint"
                  : ele?.status === "Approved" ||
                    ele?.status === "Completed" ||
                    ele?.status === "Report Pending" ||
                    ele?.status === "Report On Hold" ||
                    ele?.status === "Confirmed"
                  ? "approve-appoint"
                  : ele?.status === "Expired"
                  ? "expire-appoint"
                  : (ele?.status === "Rejected" ||
                      ele?.status === "No Show" ||
                      ele?.status === "Cancelled") &&
                    "reject-appoint"
              }`}
              key={index}
            >
              <div
                className="topsec"
                style={{
                  backgroundColor: styleTopSecBackgroundColor(ele?.status),
                  color: styleTopSecColor(ele?.status),
                  border: styleTopSecBackgroundColor(ele?.status),
                }}
              >
                <div className="row">
                  <div className="col-lg-6 col-6">
                    <div className="select_single">
                      {funnelSelected === "pendingConfirmation" && (
                        <input
                          type="checkbox"
                          onClick={(e) =>
                            e?.target?.checked
                              ? (setMultiSelect([...multiSelect, ele]),
                                setIsSelectAll(true))
                              : (setMultiSelect(filterAppointmentId(ele)),
                                setIsAcceptAll(false),
                                setIsSelectAll(false))
                          }
                          checked={multiSelect?.some(
                            (element) =>
                              element?.appointmentId === ele?.appointmentId
                          )}
                          className="form-check-input"
                        />
                      )}
                      <h2>
                        {ele?.valueType === "PRODUCT"
                          ? "Case ID"
                          : "Policy Number"}
                        -{ele?.caseNo}
                        {ele?.policyRefNo}
                      </h2>
                      <h2>
                        {ele?.valueType === "PRODUCT"
                          ? ""
                          : "Case ID - "} {ele?.ibuCaseID}
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6 col-6">
                    <h2 className="float-end" style={{ marginRight: "10px" }}>
                      Status -{" "}
                      {ele?.status === "Approved" ? "Accepted" : ele?.status}
                      &nbsp;&nbsp;
                      <i
                        className="fa fa-history icon-history-appoinment"
                        onClick={() => {
                          setIsHistoryPopup({
                            isOpen: true,
                            cardDetails: ele,
                          });
                        }}
                        style={{
                          color: styleCustomerColor(ele?.status),
                          fontSize: "17px",
                        }}
                      ></i>
                      <a
                        href={`/ProvidersPortal/appointmentdetailstemplate/${JSON.stringify(
                          {
                            valueType: ele?.valueType,
                            AppointmentId: ele?.appointmentId,
                          }
                        )}`}
                        target="_blank"
                      >
                        <i
                          className="fa fa-print icon-history-appoinment"
                          style={{
                            color: styleCustomerColor(ele?.status),
                            fontSize: "17px",
                            marginLeft: "10px",
                          }}
                        ></i>
                      </a>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="bottomsec">
                <div className="row">
                  <div className="col-lg-4">
                    <h2 style={{ color: styleCustomerColor(ele?.status) }}>
                      {ele?.proposerName} {ele?.gender}
                    </h2>
                    <p>
                      <i className="fas fa-mail-bulk"></i>&nbsp;&nbsp;
                      {ele?.email}
                    </p>
                    <p>
                      <i className="fa fa-phone"></i> &nbsp;&nbsp;
                      {ele?.mobileno}
                    </p>
                    <p className="bottomtxt" style={{ fontWeight: "700" }}>
                      <i className="fa-regular fa-calendar-days icon"></i>
                      &nbsp;&nbsp;
                      {moment(ele?.appointmentDateTime).format("Do MMMM YYYY")}-
                      &nbsp;
                      {moment(ele?.appointmentDateTime).format("hh:mm A")}
                    </p>
                    <p className="bottomtxt" style={{ fontWeight: "700" }}>
                      DOB : 
                      &nbsp;&nbsp;
                      {moment(ele?.dob).format("Do MMMM YYYY")}
                    </p>
                    {ele?.modeOfPayment === "Prepaid" ? (
                      <p
                        className="bottomtxt"
                        style={{ fontWeight: "700", color: "#5157a0" }}
                      >
                        <img src="./images/paymenticontick.png" width={16} />
                        &nbsp;&nbsp;
                        {ele?.modeOfPayment}
                      </p>
                    ) : (
                      <p
                        className="bottomtxt"
                        style={{ fontWeight: "700", color: "#5157a0" }}
                      >
                        <i className="fas fa-wallet icon"></i> &nbsp;&nbsp;
                        {ele?.modeOfPayment}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4">
                    {getRole() === "NetworkAdmin" && (
                      <p>
                        <span>Provider Name: </span> {ele?.providername}
                      </p>
                    )}
                    <p>
                      <span>Visit Type: </span> {ele?.visit}
                    </p>
                    <p>
                      <span> Client Name: </span> {ele?.clientName}
                    </p>
                    {ele?.visit !== "Centre Visit" && (
                      <p style={{ minHeight: "60px" }}>
                        <span> Customer Address: </span>
                        {ele?.address === ""
                          ? " N/A"
                          : isShowMoreAddress && cardIndex === index
                          ? ele?.address
                          : ele?.address?.split(" ")?.slice(0, 20)?.join(" ")}
                        <span
                          onClick={() => {
                            setCardIndex(index);
                            setIsShowMoreAddress(
                              isShowMoreAddress && cardIndex === index
                                ? false
                                : true
                            );
                            setIsShowMore(false);
                          }}
                          style={{ color: "#5157a0", cursor: "pointer" }}
                        >
                          {ele?.address.split(" ").length < 20 ? (
                            ""
                          ) : isShowMoreAddress && cardIndex === index ? (
                            <span
                              style={{ color: "#5157a0", cursor: "pointer" }}
                            >
                              &nbsp;&nbsp;view less
                            </span>
                          ) : (
                            "...view more"
                          )}
                        </span>
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4">
                    {ele?.specialityName === null ? (
                      <p>
                        <span> Package Name: </span> {ele?.packageName}
                      </p>
                    ) : (
                      <p>
                        <span> Doctor Name: </span> {ele?.doctorName}
                      </p>
                    )}
                    {ele?.specialityName === null ? (
                      <p style={{ minHeight: "60px" }}>
                        <span> Test Details: </span>
                        {isShowMore && cardIndex === index ? (
                          ele?.tests
                        ) : (
                            ele?.tests?.split(" ")?.slice(0, 20)?.join(" ")
                        )}
                        <span
                          onClick={() => {
                            setCardIndex(index);
                            setIsShowMore(
                              isShowMore && cardIndex === index ? false : true
                            );
                            setIsShowMoreAddress(false);
                          }}
                          style={{ color: "#5157a0", cursor: "pointer" }}
                        >
                          {ele?.tests?.split(" ").length < 20 ? (
                            ""
                          ) : isShowMore && cardIndex === index ? (
                            <span
                              style={{ color: "#5157a0", cursor: "pointer" }}
                            >
                              &nbsp;&nbsp;view less
                            </span>
                          ) : (
                            "...view more"
                          )}
                        </span>
                      </p>
                    ) : (
                      <p>
                        <span> Speciality Name: </span> {ele?.specialityName}
                      </p>
                    )}
                    
                    {console.log("sdasd", ele?.tests?.trim(" ")?.split(",").length , ele?.additionalTest?.trim("")?.split(",").length)}
                    {ele?.additionalTest && <p  style={{ fontWeight: "700", color: "#696666" }}>
                      <span> Additional Test: </span> {ele?.additionalTest}
                      </p>}
                    <div className="div-accept-reject">
                      {ele?.status === "Pending" ? (
                        <>
                          <button
                            className="accept-btn"
                            type="button"
                            onClick={() => {
                              
                              ChangeStatusHandler(
                                ele,
                                "A",
                                `Are you sure you want to "Accept" the booking ?`
                              );
                            }}
                            disabled={
                              getRole() === "NetworkAdmin" &&
                              !getNetworkMenuId()?.canEdit
                            }
                          >
                            Accept
                          </button>
                          <button
                            className="reject-btn-indivitual"
                            type="button"
                            onClick={() => {
                              checkShowPopupAcceptRejectHandler(ele, "R");
                              setIsRejectPopup({
                                isOpen: true,
                                cardDetails: ele,
                              });
                            }}
                            disabled={
                              getRole() === "NetworkAdmin" &&
                              !getNetworkMenuId()?.canEdit
                            }
                          >
                            Reject
                          </button>
                        </>
                      ) : (ele?.status === "Confirmed" ||
                          ele?.status === "Approved") && moment(ele?.appointmentDateTime).format("L") <=
                          moment().format("L")
                        ? (
                        <>
                          <button
                            className="accept-btn"
                            type="button"
                            onClick={() => {
                              ChangeStatusHandler(
                                ele,
                                "S",
                                `Are you sure you want to Mark the Patient Visit to "Show" ?`
                              );
                            }}
                            disabled={
                              getRole() === "NetworkAdmin" &&
                              !getNetworkMenuId()?.canEdit
                            }
                          >
                            Show
                          </button>
                          
                          {(ele?.tests?.split(",").length > 1 ||( ele?.tests?.split(",").length >= 1 && ele.additionalTest !== "")) && <button
                           className="accept-btn"
                            data-bs-toggle="modal"
                            style={{marginLeft:"10px"}}
                            data-bs-target="#appointmentParitalShow"
                            type="button"
                            onClick={() => {
                              setPartialShow({open:true,data:ele})
                              dispatch(GetPartialTestDetailsList(ele?.appointmentId,ele?.valueType
                              ))
                            }}
                            disabled={
                              getRole() === "NetworkAdmin" &&
                              !getNetworkMenuId()?.canEdit
                            }
                          >
                           Partial Show
                          </button>}
                          <button
                            className="reject-btn-indivitual"
                            type="button"
                            onClick={() => {
                              ChangeStatusHandler(
                                ele,
                                "N",
                                `Are you sure you want to Mark the Patient Visit to "No Show" ?`
                              );
                            }}
                            disabled={
                              getRole() === "NetworkAdmin" &&
                              !getNetworkMenuId()?.canEdit
                            }
                          >
                            No Show
                          </button>
                          
                          
                        </>
                      ) : (ele?.status === "Confirmed" ||
                          ele?.status === "Approved") &&
                        moment(ele?.appointmentDateTime).format("x") >=
                          moment().format("x") ? (
                        <button
                          className="reject-btn-indivitual"
                          type="button"
                          onClick={() => {
                            checkShowPopupAcceptRejectHandler(ele, "R");
                            setIsRejectPopup({
                              isOpen: true,
                              cardDetails: ele,
                            });
                          }}
                          disabled={
                            getRole() === "NetworkAdmin" &&
                            !getNetworkMenuId()?.canEdit
                          }
                        >
                          Reject
                        </button>
                      ) : ele?.status === "Report Pending" ||
                        ele?.status === "Report On Hold"  ? 
                        //|| ele?.status === "Partial Show" 
                        (
                        <button
                          className="accept-btn"
                          type="button"
                          onClick={async () => {
                            await checkShowPopupHandler(ele, "U");
                            setIsUploadReportPopup({
                              isOpen: true,
                              cardDetails: ele,
                              isUploadReport: true,
                            });
                            // getDispatch(IS_SHOW_POPUP, true, dispatch);
                          }}
                          disabled={
                            getRole() === "NetworkAdmin" &&
                            !getNetworkMenuId()?.canEdit
                          }
                        >
                          Upload Report
                        </button>
                      ) : ele?.status === "Completed" ? (
                        <button
                          className="accept-btn"
                          type="button"
                          onClick={async () => {
                            getDispatch(IS_SHOW_POPUP, true, dispatch);
                            setIsUploadReportPopup({
                              isOpen: true,
                              cardDetails: ele,
                              isUploadReport: false,
                            });
                          }}
                        >
                          View Report
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div className="mt-4" onClick={() => setIsSelectAll(false)}>
          {getAppoinmentDetail?.totalRow > 10 && (
            <PaginatedItems
              totalCount={getAppoinmentDetail?.totalRow}
              perPageData={searchFilter?.rows}
            />
          )}
        </div>
      </div>
      <Modal
        isOpen={isHistoryPopup?.isOpen}
        className="modal-history-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <HistoryPopup
          isHistoryPopup={isHistoryPopup}
          setIsHistoryPopup={setIsHistoryPopup}
        />
      </Modal>
      <Modal
        isOpen={isConfirmationPopup?.isOpen && appoinmentReducer?.isShowPopup}
        className="modal-confirmation-popup modal-noshow-popup"
        overlayClassName="overlay-confirmation-popup network-z-index"
        ariaHideApp={false}
      >
        <ConfirmationPopup
          isConfirmationPopup={isConfirmationPopup}
          setIsConfirmationPopup={setIsConfirmationPopup}
          searchFilter={searchFilter}
          apiParams={apiParams}
        />
      </Modal>
      <Modal
        isOpen={isUploadReportPopup?.isOpen && appoinmentReducer?.isShowPopup}
        className="modal-upload-popup"
        overlayClassName="overlay-upload-popup network-z-index"
        ariaHideApp={false}
      >
        <UploadReportPopup
          isUploadReportPopup={isUploadReportPopup}
          setIsUploadReportPopup={setIsUploadReportPopup}
          searchFilter={searchFilter}
          apiParams={apiParams}
        />
      </Modal>
      <Modal
        isOpen={isRejectPopup?.isOpen && appoinmentReducer?.isShowPopup}
        className="modal-reject-popup"
        overlayClassName="overlay-reject-popup network-z-index"
        ariaHideApp={false}
      >
        <RejectConfirmationPopup
          isRejectPopup={isRejectPopup}
          setIsRejectPopup={setIsRejectPopup}
          searchFilter={searchFilter}
          apiParams={apiParams}
        />
      </Modal>
      <div
          class="modal fade"
          id="appointmentParitalShow"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered " role="document">
         {partialShow?.open && <PartialShow setPartialShow={setPartialShow} partialShow={partialShow} searchFilter={searchFilter} apiParams={apiParams}/>}
          </div>
        </div>
      
    </>
  );
};

export default AppointmentCardContainer;
